export default __webpack_public_path__ + "static/media/wave.007a24a8.svg";